export default __webpack_public_path__ + "locales/sk/BackupCodesDialog.json?hash=bc22976272b2ea4c6d150448b6fcdbd6";